<template>
  <section class="preview">
    <form class="form" v-if="!loadingGeneral" novalidate @submit.prevent="crear">
      <!-- Styled -->
      <mdb-input
        placeholder="Nombre"
        class="mb-3 mt-0"
        v-model="name"
        required
        invalidFeedback="Coloca el nombre"
      >
        <span class="input-group-text md-addon" slot="prepend">Nombre(Codigo)</span>
      </mdb-input>

      <mdb-input
        placeholder="Nombre de ciudad"
        class="mb-3 mt-0"
        v-model="cityName"
        required
        invalidFeedback="Dirección de calle"
      >
        <span class="input-group-text md-addon" slot="prepend">Nombre de ciudad</span>
      </mdb-input>

      <mdb-input
        placeholder="Latitud"
        class="mb-3 mt-0"
        v-model="latitud"
        required
        invalidFeedback="latitud"
      >
        <span class="input-group-text md-addon" slot="prepend">Latitud</span>
      </mdb-input>

      <mdb-input
        placeholder="Longitud"
        class="mb-3 mt-0"
        v-model="longitud"
        required
        invalidFeedback="Longitud"
      >
        <span class="input-group-text md-addon" slot="prepend">Longitud</span>
      </mdb-input>

      <mdb-input
        placeholder="ID Ciudad"
        class="mb-3 mt-0"
        v-model="idCity"
        required
        invalidFeedback="id CIudad"
      >
        <span class="input-group-text md-addon" slot="prepend">id Ciudad</span>
      </mdb-input>

      <div class="form-group">
        <label class="typo__label">
          Estado
          <!--<i class="fas fa-plus-circle icono-crear mr-1" @click="modal = true"></i>-->
        </label>
        <multiselect
          v-model="stateSelected"
          :options="states"
          :multiple="false"
          :close-on-select="true"
          :clear-on-select="false"
          :preserve-search="false"
          placeholder="Selecciona un estado"
          label="name"
          track-by="id"
          :preselect-first="false"
        ></multiselect>
      </div>

      <div class="text-center">
        <mdb-btn type="submit" color="primary" :disabled="isLoading">
          <span v-if="!isLoading">Editar</span>
          <semipolar-spinner :animation-duration="2000" :size="30" color="#ffffff" v-if="isLoading"></semipolar-spinner>
        </mdb-btn>
      </div>
    </form>

    <div v-else class="div-loading">
      <semipolar-spinner :animation-duration="2000" :size="60" color="#CCCCCC"></semipolar-spinner>
    </div>
  </section>
</template>

<script>
import Multiselect from "vue-multiselect";
import { SemipolarSpinner } from "epic-spinners";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbTooltip
} from "mdbvue";
import store from "../../store";
export default {
  name: "modal-1",
  components: {
    mdbInput,
    mdbBtn,
    SemipolarSpinner,
    Multiselect,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalTitle,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbIcon,
    mdbTextarea,
    mdbTooltip
  },
  props: {
    onClick: Function,
    codPostal: Object
  },
  data: () => {
    return {
      isLoading: false,
      modal: false,
      id: "",
      name: "",
      cityName: "",
      latitud: "",
      longitud: "",
      idCity: "",
      idState: "",
      state: "",
      states: [],
      stateSelected: {},
      isLoadingLine: false,
      loadingGeneral: false
    };
  },
  async mounted() {
    var respuesta = await this.getStates();
    const { codPostal } = this;
    this.name = codPostal.name;
    this.id = codPostal.id;
    this.cityName = codPostal.city_name;
    this.idCity = codPostal.city_id;
    this.idState = codPostal.state_id.id;
    this.latitud = codPostal.lat;
    this.longitud = codPostal.lng;
    this.stateSelected = {
      id: codPostal.state_id.id,
      name: codPostal.state_id.name
    };
  },
  methods: {
    async getStates() {
      var states = store.getters.getStates;
      if (states.length == 0) {
        this.loadingGeneral = true;
        await store.dispatch("getStates").then(() => {
          states = store.getters.getStates;
          this.states = states;
          this.loadingGeneral = false;
          return;
        });
      } else {
        this.states = states;
        return;
      }
    },
    crear(event) {
      event.target.classList.add("was-validated");
      var {
        id,
        name,
        cityName,
        latitud,
        longitud,
        idCity,
        idState,
        stateSelected
      } = this;
      idState = stateSelected.id;
      this.isLoading = true;
      if (
        name == "" ||
        cityName == "" ||
        latitud == "" ||
        longitud == "" ||
        idCity == "" ||
        idState == ""
      ) {
        this.isLoading = false;
      } else {
        var codPostal = {
          id,
          name,
          cityName,
          latitud,
          longitud,
          idCity,
          idState
        };
        store.dispatch("editCodPostal", codPostal).then(() => {
          this.name = "";
          this.cityName = "";
          this.latitud = "";
          this.longitud = "";
          this.idCity = "";
          this.stateSelected = [];
          this.idState = "";
          this.onClick();
          this.isLoading = false;
        });
      }
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.prueba-circulo {
  background-image: url("");
  background-repeat: no-repeat;
  width: 200px;
  height: 200px;
  background: #cccccc;
  border-radius: 100%;
  position: relative;
}
.form {
  position: relative;
  bottom: 80px;
}

.div-loading {
  bottom: 80px;
  position: relative;
  width: 100%;
  height: auto;
  padding-left: 45%;
}
</style>